export const gtagEvent = (action, params) => {
    if (typeof window !== 'undefined' && window.gtag) {
        console.log('gtagEvent called with action:', action, 'and params:', params)
        window.gtag('event', action, params)
    } else {
        console.warn('gtag not found')
    }
}

export const setUserId = (userId) => {
    if (typeof window !== 'undefined' && window.gtag) {
        console.log(userId, 'dedededuserid')
        window.gtag('set', { user_id: userId })
    }
}
